import React from 'react';
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Grid, Typography } from '@material-ui/core';
import { Link } from 'react-router-dom';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    label: {
      marginBottom: '8px !important',
    },
    value: {
      textTransform: 'none',
      color: theme.palette.primary.main,
      fontWeight: 'bold',
      marginBottom: '8px !important',
      '&:hover': {
        textDecoration: 'underline',
      },
    },
  })
);

interface LinkFieldProps {
  /**
   * Field label.
   */
  label?: string;
  /**
   * Field value.
   */
  value?: string | JSX.Element;
  /**
   * Href.
   */
  href: string;

  /**
   * target
   * @default _blank
   */
  target?: string;
}

export function LinkField({
  label,
  value,
  href,
  target = '_blank',
}: LinkFieldProps) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={4}>
        <Typography variant="body1" className={classes.label}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <a
          href={`${process.env.PUBLIC_URL}/${href}`}
          rel="noopener noreferer"
          target={target}
          className={classes.value}
        >
          {value}
        </a>
      </Grid>
    </Grid>
  );
}

type LinkFieldRouterProps = Omit<LinkFieldProps, 'href'> & { to: string };

export function LinkFieldRouter({
  label,
  value,
  to,
  target = '_blank',
}: LinkFieldRouterProps) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={4}>
        <Typography variant="body1" className={classes.label}>
          {label}
        </Typography>
      </Grid>
      <Grid item xs={8}>
        <Link
          to={to}
          rel="noopener noreferer"
          target={target}
          className={classes.value}
        >
          {value}
        </Link>
      </Grid>
    </Grid>
  );
}

type MultiLinkFieldRouterProps = Omit<LinkFieldRouterProps, 'to' | 'value'> & {
  links: {
    to: string;
    linkLabel: string;
    labelPrefix?: string;
    labelPostfix?: string;
  }[];
};
export function MultiLinkFieldRouter({
  label,
  links,
  target = '_blank',
}: MultiLinkFieldRouterProps) {
  const classes = useStyles();
  return (
    <Grid container>
      <Grid item xs={4}>
        <Typography variant="body1" className={classes.label}>
          {label}
        </Typography>
      </Grid>

      {links.map((link, index) => (
        <>
          {index > 0 && <Grid item xs={4} />}
          <Grid item xs={8}>
            {link.labelPrefix}
            <Link
              to={link.to}
              rel="noopener noreferer"
              target={target}
              className={classes.value}
            >
              {link.linkLabel}
            </Link>
            {link.labelPostfix}
          </Grid>
        </>
      ))}
    </Grid>
  );
}
